import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import moment from "moment";

export default function ExpenseSummary(props) {
    const {
        darkState,
        month,
        periodLabel,
        periodHeading,
        periodSubheading,
        title,
        amount,
        approvedAmount,
        balanceAmount,
        details = [],
        approvedLabel = "Approved",
    } = props;

    const headingLabel = React.useMemo(() => {
        if (periodHeading) {
            return periodHeading;
        }
        if (periodLabel) {
            return periodLabel;
        }
        if (month) {
            return moment(month).format("MMMM YYYY");
        }
        return "";
    }, [periodHeading, periodLabel, month]);

    const subheadingLabel = React.useMemo(() => {
        if (periodSubheading) {
            return periodSubheading;
        }
        return "";
    }, [periodSubheading]);
    return (
        <Card
            variant="outlined"
            sx={{
                my: 1,
                width: "100%",
                maxWidth: "600px",
                border: darkState ? "1.5px solid" : "3px solid",
                borderColor: "primary.main",
                borderRadius: "16px",
            }}
        >
            <CardContent
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                {headingLabel ? (
                    <Typography
                        style={{ fontWeight: "700" }}
                        mb={subheadingLabel ? 0.5 : 1}
                        variant="h4"
                        component="div"
                    >
                        {headingLabel}
                    </Typography>
                ) : null}
                {subheadingLabel ? (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                        sx={{ fontWeight: 500 }}
                    >
                        {subheadingLabel}
                    </Typography>
                ) : null}
                <Typography variant="h6" color="text.secondary" gutterBottom>
                    {title}
                </Typography>
                {approvedAmount !== undefined && (
                    <Typography
                        variant="body1"
                        color="success.main"
                        gutterBottom
                    >
                        {`${approvedLabel}: $${parseFloat(
                            approvedAmount
                        ).toFixed(2)}`}
                    </Typography>
                )}
                {balanceAmount !== undefined && (
                    <Typography
                        variant="body1"
                        color="warning.main"
                        gutterBottom
                    >
                        {`Balance Due: $${parseFloat(balanceAmount).toFixed(
                            2
                        )}`}
                    </Typography>
                )}
                <Typography variant="body1" color="text.secondary" gutterBottom>
                    {amount !== ""
                        ? `Total: $${parseFloat(amount).toFixed(2)}`
                        : ""}
                </Typography>
                {details
                    .filter((text) => Boolean(text))
                    .map((text, index) => (
                        <Typography
                            key={`${title}-detail-${index}`}
                            variant="caption"
                            color="text.secondary"
                            gutterBottom
                        >
                            {text}
                        </Typography>
                    ))}
            </CardContent>
        </Card>
    );
}
